import React, { Component } from 'react';

class getSeleccionCuenta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id_cuenta: props.id_cuenta,
      cuenta_activas: []
    };
  }

  componentDidMount() {
    this.consultarCuentaActivasAPI();
  }

  consultarCuentaActivasAPI = () => {
    const { id_cuenta } = this.state;
    const url = `${this.props.url_proxyurl}${this.props.url_global}webservices/getCuentasActivas/${id_cuenta}`;

    fetch(url)
      .then(res => res.json())
      .then(data => {
        this.setState({ cuenta_activas: data });
      })
      .catch(console.log);
  };

  render() {
    const { cuenta_activas } = this.state;

    return (
      <div style={styles.wrapper}>
        <div style={styles.content}>
          <h2 style={styles.title}>Seleccione Cuenta</h2>

          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th>Cuenta</th>
                  <th>Estado</th>
                  <th>Cliente</th>
                  <th>Total</th>
                  <th>Vendedor</th>
                </tr>
              </thead>
              <tbody>
                {cuenta_activas.map((cuenta, index) => (
                  <tr
                    key={index}
                    onClick={() => this.props.getSeleccionarCuentaA(cuenta.id_cabecera)}
                    style={styles.row}
                  >
                    <td>{cuenta.cuenta}</td>
                    <td>{cuenta.Comprobante}</td>
                    <td>{cuenta.Cliente}</td>
                    <td>${parseFloat(cuenta.Total).toFixed(2)}</td>

                    <td>{cuenta.Vendedor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={styles.buttonContainer}>
            <button className="btn_teclado_opcion_vendedor" style={{"width":"200px"}} onClick={this.props.Abtn_encerar_cuenta}>
              SALIR
            </button>
          </div>
        </div>
      </div>
    );
  }
}

// Estilos en línea para diseño profesional
const styles = {
  wrapper: {
    width: '100%',
    height: '100%',
    backgroundColor: '#f4f6f8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    width: '90%',
    maxWidth: '800px',
    backgroundColor: '#ffffff',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    marginBottom: '20px',
    color: '#333',
    fontSize: '24px',
    fontWeight: '600'
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    color: '#333'
  },
  row: {
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  buttonContainer: {
    marginTop: '20px'
  }
};

export default getSeleccionCuenta;
